import { render } from "./AdminWaiting.vue?vue&type=template&id=91f64fe2"
import script from "./AdminWaiting.vue?vue&type=script&lang=js"
export * from "./AdminWaiting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__